
/* injects from baggage-loader */

'use strict';

export default class RaiseFundsController {

	constructor($log) {
		'ngInject';

		this.$log = $log;

	}

	$onInit() {

	}

}



// WEBPACK FOOTER //
// ./src/app/pages/raise-funds/raise-funds.controller.js